import React from "react";
import { createRoot } from "react-dom/client";
import { CookieConsentBanner } from "./components/CookieConsentBanner";
import { COOKIE_POLICY_PATH } from "../../shared/constants";

const hookDiv = document.getElementById("cookie-consent-banner-hook");

if (hookDiv !== null && window.Cookiebot && window.location.pathname !== COOKIE_POLICY_PATH) {
  createRoot(hookDiv).render(<CookieConsentBanner />);
}
